import { useState } from 'react';
import clsx from 'clsx';
import { FaTimes } from 'react-icons/fa';
import ReportFeedbackTitleIcon from '../../styles/img/reports/report-feedback-title.svg';
import PrimaryButton from '../button/PrimaryButton';

const FeedbackForm = ({ 
  selectedOption, 
  onClose, 
  onSubmit, 
  isVisible, 
  isSubmitting,
  initialEmail = '' 
}) => {
  const [email, setEmail] = useState(initialEmail);
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim() || !email.trim()) return;

    onSubmit({
      email: email.trim(),
      message: message.trim()
    });
  };

  const isFormValid = message.trim() && email.trim() && !isSubmitting;

  return (
    <div className={`absolute top-0 left-0 w-full transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] h-full ${
      isVisible ? 'translate-x-0' : 'translate-x-full'
    }`}>
      <div>
        {/* Top Header with close button */}
        <div className="flex items-center justify-between pt-6 pb-6 px-6 shadow-lg relative">
          <div className="flex items-center flex-1 justify-center">
            <div className="w-14 h-14 mr-3">
              <img src={ReportFeedbackTitleIcon} alt="caller" className="w-14 h-14" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900">Donner mon avis</h3>
          </div>

          <button
            type="button"
            onClick={onClose}
            onKeyDown={(e) => e.key === 'Enter' && onClose()}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
          >
            <FaTimes className="w-5 h-5 fill-[darkgray]" />
          </button>
        </div>

        {/* Selected Option Banner */}
        {selectedOption && (
          <div className="w-full mb-6">
            <div className={clsx(
              "flex items-center p-6 w-full justify-center",
              { "bg-blue-50 text-blue-600": selectedOption?.id === "suggestion" },
              { "bg-orange-50 text-orange-600": selectedOption?.id === "problem" },
            )}>
              <div className="w-8 h-8 rounded-lg flex items-center justify-center mr-3">
                <img src={selectedOption.icon} alt={selectedOption.title} className="w-5 h-5" />
              </div>
              <h3 className="geomanistmedium text-center font-semibold text-[14px]"
                  style={{ color: selectedOption.iconColor }}>
                {selectedOption.title}
              </h3>
            </div>
          </div>
        )}
      </div>

      {/* Form Content */}
      <div className="px-6 h-full overflow-y-auto overflow-x-hidden mb-20">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Email Field */}
          <div>
            <label htmlFor="email"
                   className="block text-xl font-medium text-gray-500 mt-5 mb-3 geomanistMedium">
              Adresse mail*
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <span className="text-gray-400 text-lg">@</span>
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="mail@mail.com"
                className="w-full geomanistRegular text-2xl pl-12 pr-4 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
                required
              />
            </div>
          </div>

          {/* Message Field */}
          <div>
            <label htmlFor="message"
                   className="block text-xl font-medium text-gray-500 mt-12 mb-3 geomanistMedium">
              Message*
            </label>
            <textarea
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="J'aimerais bien ..."
              className="w-full geomanistRegular p-4 border border-gray-200 rounded-2xl resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-xl bg-white"
              rows={6}
              required
            />
          </div>

          {/* Submit Button */}
          <div className="!mt-10 pt-4">
            <PrimaryButton
              label="Envoyer à l'équipe"
              onClick={handleSubmit}
              disabled={!isFormValid}
              className={clsx("w-full", { "opacity-30": !isFormValid })}
              isLoading={isSubmitting}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackForm; 